import p from "./index48.js";
import t from "./index46.js";
import "./index47.js";
class d extends p {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const a = e.mask;
    a && (e.validate = (s) => s.search(a) >= 0), super._update(e);
  }
}
t.MaskedRegExp = d;
export {
  d as default
};
